import { render, staticRenderFns } from "./QuotedSublets.vue?vue&type=template&id=0a846113"
import script from "./QuotedSublets.vue?vue&type=script&lang=js"
export * from "./QuotedSublets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a846113')) {
      api.createRecord('0a846113', component.options)
    } else {
      api.reload('0a846113', component.options)
    }
    module.hot.accept("./QuotedSublets.vue?vue&type=template&id=0a846113", function () {
      api.rerender('0a846113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/QuotedSublets.vue"
export default component.exports